// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__coxTn"};